import { client } from "./index";
import type { SelectUser } from "../types/backend";
import config from "../constants/config";

export async function authenticatedUser(): Promise<SelectUser | null> {
  try {
    const response = await (client).v1.users.me.$get();
    
    if (!response.ok) {
      throw new Error("Failed to fetch authenticated user");
    }
    
    const data = await response.json();
    return data as SelectUser;
  } catch (error) {
    if (error instanceof Error && error.name === "APIError") {
      throw error;
    }
    throw error;
  }
}

export async function logoutUser(): Promise<{ message: string }> {
  try {
    const response = await (client).v1.users.me.logout.$post();
    
    if (!response.ok) {
      const data = await response.json();
      return data;
    }
    
    return await response.json();
  } catch (error) {
    // Re-throw APIError instances, wrap other errors
    if (error instanceof Error && error.name === "APIError") {
      throw error;
    }
    throw error;
  }
}

export function getGoogleOAuthUrl(): string {
  // Construct the Google OAuth URL directly with state parameter for admin
  const clientId = config.oauthGoogleClientId;
  const redirectUri = encodeURIComponent(
    config.apiUrl + config.oauthGoogleCallbackPath
  );
  const scope = encodeURIComponent("email profile openid");
  
  // Include state parameter with admin origin and tag
  const state = encodeURIComponent(
    btoa(
      JSON.stringify({
        origin: window.location.origin,
        tag: "admin",
      })
    )
  );
  
  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&response_type=code&access_type=offline&state=${state}`;

  return authUrl;
}